export class CourseStatus {
    id: string;
    name: string;
}

export const COURSE_STATUS: CourseStatus[] = [
    {
        id: 'opened',
        name: 'Opened'
    },
    {
        id: 'closed',
        name: 'Closed'
    }
];




// WEBPACK FOOTER //
// ./src/holiday/models/CourseStatus.ts